__turbopack_context__.v({
  "focus": "GradientSelector-module-scss-module__3Txs4a__focus",
  "icon": "GradientSelector-module-scss-module__3Txs4a__icon",
  "menuItem": "GradientSelector-module-scss-module__3Txs4a__menuItem",
  "menuList": "GradientSelector-module-scss-module__3Txs4a__menuList",
  "selector": "GradientSelector-module-scss-module__3Txs4a__selector",
});
